import { State } from '../state';

export const SiteSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    site: (state: State) => state.Site,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    excludedStates: (state: State) => state.Site.excludedStates,

    selectedCountry: (state: State) => state.Site.country,

    selectedState: (state: State) => state.Site.state,

};
